<app-header></app-header>

<!-- Hero Start -->
<section class="bg-half-170 d-table w-100"
  style="background: url('{{getContentByServiceName(pageName)?.background}}') center center;">
  <div class="container">
    <div class="row align-items-center position-relative">
      <div class="col-lg-6 col-md-12 py-5">
        <div class="title-heading mt-4 text-center text-lg-start">
          <h1 class="heading mb-3 title-dark text-white">{{ getContentByServiceName(pageName)?.content6}}</h1>
          <p class="para-desc text-white-50">{{ getContentByServiceName(pageName)?.p}}</p>
          <div class="mt-4">
            <a routerLink="/signup" class="btn btn-light">{{'Home.Signup' |translate }}</a>
          </div>
        </div>
      </div><!--end col-->

      <div class="col-lg-6 col-md-12 mt-4 pt-2">
        <div class="position-relative">
          <div class="software_hero">
            <img src="{{ getContentByServiceName(pageName)?.labtopmockup }}" class="img-fluid d-block" alt="">
          </div>
        </div>
      </div><!--end col-->
    </div><!--end row-->
  </div><!--end container-->
</section><!--end section-->
<div class="position-relative">
  <div class="shape overflow-hidden text-white">
    <svg viewBox="0 0 2880 250" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M720 125L2160 0H2880V250H0V125H720Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!-- Hero End -->


<!-- Section Start -->
<section class="section">
  <!-- Start Features -->
  <div class="container">
    <div class="section-title mb-4 pb-2 justify-content-center text-center">
      <h4 class="title mb-4">{{ getContentByServiceName(pageName)?.title }}</h4>
      <p class="text-muted para-desc mx-auto mb-0">{{'Home.Services.ServicesP' |translate }}</p>
    </div>

    <div class="row">
      <div class="col-md-4 col-12 mt-5 p-4">
        <div class="features text-center">
          <div class="image position-relative d-inline-block">
            <i class="fa fa-coins h1 text-secondary"></i>
          </div>

          <div class="content mt-4">
            <p class="text-muted mb-0">{{'Home.Services.Content1' |translate }}</p>
          </div>
        </div>
      </div><!--end col-->

      <div class="col-md-4 col-12 mt-5 p-4">
        <div class="features text-center">
          <div class="image position-relative d-inline-block">
            <i class="fa fa-circle-dollar-to-slot h1 text-secondary"></i>
          </div>

          <div class="content mt-4">
            <p class="text-muted mb-0">{{'Home.Services.Content2' |translate }}</p>
          </div>
        </div>
      </div><!--end col-->

      <div class="col-md-4 col-12 mt-5 p-4">
        <div class="features text-center">
          <div class="image position-relative d-inline-block">
            <i class="fa fa-circle-check h1 text-secondary"></i>
          </div>

          <div class="content mt-4">
            <p class="text-muted mb-0">{{'Home.Services.Content3' |translate }}</p>
          </div>
        </div>
      </div><!--end col-->

      <div class="col-md-4 col-12 mt-5 p-4">
        <div class="features text-center">
          <div class="image position-relative d-inline-block">
            <i class="fa fa-clock h1 text-secondary"></i>
          </div>

          <div class="content mt-4">
            <p class="text-muted mb-0">{{'Home.Services.Content4' |translate }}</p>
          </div>
        </div>
      </div><!--end col-->

      <div class="col-md-4 col-12 mt-5 p-4">
        <div class="features text-center">
          <div class="image position-relative d-inline-block">
            <i class="fa fa-business-time h1 text-secondary"></i>
          </div>

          <div class="content mt-4">
            <p class="text-muted mb-0">{{'Home.Services.Content5' |translate }}</p>
          </div>
        </div>
      </div><!--end col-->

      <div class="col-md-4 col-12 mt-5 p-4">
        <div class="features text-center">
          <div class="image position-relative d-inline-block">
            <i class="fa fa-square-plus h1 text-secondary"></i>
          </div>

          <div class="content mt-4">
            <p class="text-muted mb-0"> {{ getContentByServiceName(pageName)?.content6}}</p>
          </div>
        </div>
      </div><!--end col-->
    </div><!--end row-->
  </div>
  <!-- End Features -->

  <div class="container my-5 ">
    <div class="card rounded bg-light shadow border-0">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-7">
            <div class=" text-center text-lg-start">
              <h5 class="mb-0">{{'Home.Services.Gateway' |translate }}</h5>
            </div>
          </div><!--end col-->

          <div class="col-sm-5 mt-4 mt-sm-0">
            <div class=" text-center text-lg-end">
              <a routerLink="/signup" class="btn btn-outline-primary"><i class="uil uil-file-bookmark-alt"></i>
                {{'Home.Signup' |translate }} </a>
            </div>
          </div><!--end col-->
        </div><!--end row -->
      </div>
    </div>
  </div><!--end container-->

  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-6">
        <img src="{{ getContentByServiceName(pageName)?.mobilemockup}}" class="img-fluid" alt="">
      </div><!--end col-->

      <div class="col-lg-7 col-md-6">
        <div class="section-title">
          <h4 class="title mb-4">{{'Home.Services.WhenToUse' |translate }}</h4>
          <p class="text-muted">{{ getContentByServiceName(pageName)?.whenToUse}}</p>
        </div>
      </div><!--end col-->
    </div><!--end row-->
  </div><!--end container-->

  <!-- start Installment Partners -->
  <div class="container my-5" *ngIf="getContentByServiceName(pageName).name== 'installmentOptions'">

    <div class="section-title justify-content-center text-center mb-4">
      <h4 class="title mb-4">{{ 'Home.Services.InstallmentPartners' | translate }}</h4>
    </div>

    <owl-carousel-o [options]="options">
      <ng-container *ngFor="let slide of installmentPartnersArray;let i=index">
        <ng-template carouselSlide>
          <div class="text-center">
            <div class="rounded shadow m-2">
              <img [src]="slide.image" class="img-fluid avatar avatar-ex-sm mx-auto" alt="">
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>

  </div>
  <!-- End Installment Partners-->
</section><!--end section-->


<!-- section End -->


<app-footer></app-footer>
